import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import removeSpacing from '../utils/removeSpace.js'
import styled from 'styled-components';

const LinkHeading = styled.h2`
   color: black;
   backface-visibility: hidden;
   transition: color .25s ease;
   will-change: transform, opacity;
     transform: translateZ(0); 
   &:hover  {
      color: ${props => props.headerColor.headerColor} !important;
    ~ div{
    video {
      visibility: visible;
      opacity: 1;
      position: relative !important;
      top: initial !important; 
      position: fixed !important;
    }
    img {
      visibility: visible;
      opacity: 1;
      min-width: 50vw;
      position: initial !important;
    }
   }
   
   
   }
`;

const OuterWrapper = styled.div`
   position: relative;
   &:hover {
     h2 {
       mix-blend-mode: exclusion;
     }
   
   }
`;


const VideoWrapper = styled.div`
   position: fixed;
   top:0;
   left: 0;
   right: 0;
   margin: 0 auto;
   display:flex;
   justify-content: center;
   flex-direction:column;
    top: 50%;
    right: 0;
    left: 0;
    margin: 0 auto;
    height: 100vh;
    -ms-transform: translateY(-47.5%);
    transform: translateY(-47.5%);
`;

let Video = styled.video`
    max-width: 80vw;
    max-height: 70vh;
    position: initial !important;
    left: 0;
    right: 0;
    margin: 0 auto;
    opacity: 0;
    z-index: 0;
    visibility: hidden;
    /* -webkit-transform: translateZ(0); */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform, opacity;
    /* display:none; */
`;



class Post extends Component {
  constructor(props) {
    super();

    this.state = {
      colors: [],
      fontColor: 'black',
      transition: 'static',
      inView: false,
      windowWidth: window.innerWidth
    }

    this.linkWrapper = React.createRef();
    this.theThumbnailVideo = React.createRef()

  }


  componentDidMount() {
    window.addEventListener('scroll', this.onScrollView);
    window.addEventListener('resize', this.changeWidth);
    this.onScrollView();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollView);
    window.removeEventListener('resize', this.changeWidth);
  }

  changeWidth = () => {
    this.setState({
      windowWidth: window.innerWidth
    })
  }

  updateColor = (current) => {
    let elements = document.querySelectorAll('.static h2');

    if (elements) {
      elements.forEach((el, index) => {
        index !== current ? el.style.color = "#f3f3f3" : el.style.color = '';
      })


    }

  }

  removeColor = (current) => {
  }

  onScrollView = () => {
    let browserHeight = window.innerHeight + 500;
    let scrollTop = window.scrollY;
    let elementTop = this.linkWrapper.current !== null ? this.linkWrapper.current.offsetTop : null;
    if (elementTop !== null) {
      if (browserHeight + scrollTop > elementTop) {
        this.setState({ inView: true });
        if (this.theThumbnailVideo.current) {
          this.theThumbnailVideo.current.pause();
        }
      }
    }
  }

  hoverLink = () => {
    if (this.theThumbnailVideo.current) {
      this.theThumbnailVideo.current.play();
    }
  }

  offLink = () => {
    if (this.theThumbnailVideo.current) {
      this.theThumbnailVideo.current.pause();
    }
  }

  render() {
    let post = this.props.postContent.fields;
    let thumb = post.thumbnail ? post.thumbnail.fields : null;
    let theThumbnail;

    // If the thumbnail is an Image
    if (thumb && this.state.inView) {
      if (thumb.file.contentType.includes('image')) {
        let imageStyles = {
          top: window.innerHeight / 2 - post.thumbnail.fields.file.details.image.height / 2 - 300
        };
        theThumbnail = <img style={imageStyles} src={post.thumbnail ? post.thumbnail.fields.file.url + '?w=600' : ""} alt={post.thumbnail ? post.thumbnail.fields.file.url : ""} />;
      } else {
        theThumbnail =
          <Video autoPlay loop muted playsInline
            poster={post.thumbnailCover ? post.thumbnailCover.fields.file.url : ''}
            ref={this.theThumbnailVideo}
          >
            <source src={post.thumbnail ? post.thumbnail.fields.file.url : ""} type="video/mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </Video>
      }
    }

    return (
      <OuterWrapper className={this.state.transition}
        headerColor={post}
        style={{ "transitionDelay": `${this.props.index * .25}ms` }}
        ref={this.linkWrapper}
      >
        {/* {this.state.windowWidth > 768 && */}

        <Link to={`/project/` + removeSpacing(post.title)}
        >
          <LinkHeading headerColor={post}
            onMouseOver={e => this.hoverLink()}
            onMouseOut={e => this.offLink()}
          >
            {post.title}
          </LinkHeading>
          <VideoWrapper>{theThumbnail}</VideoWrapper>

        </Link>
        {/* } */}
      </OuterWrapper>
    );
  }
}

export default Post;
